module.exports = __webpack_public_path__ + "static/media/british-indian-ocean-territory.343a3e8a.svg";